import request from '@/utils/request'

// ===================== 节点管理 =====================

// 查询某个剧壳下的所有节点
export function listBranchNode(query) {
    return request({
      url: '/video/branch/nodes',   // 改成后端 GET /video/branch/nodes
      method: 'get',
      params: query
    })
  }
  
  // 查询节点详情
  export function getBranchNode(nodeId) {
    return request({
      url: `/video/branch/node/${nodeId}`, // GET /video/branch/node/{id}
      method: 'get'
    })
  }
  
  // 新增节点
  export function addBranchNode(data) {
    return request({
      url: '/video/branch/node',  // POST /video/branch/node
      method: 'post',
      data: data
    })
  }
  
  // 修改节点
  export function updateBranchNode(data) {
    return request({
      url: '/video/branch/node',  // PUT /video/branch/node
      method: 'put',
      data: data
    })
  }
  
  // 删除节点
  export function delBranchNode(nodeId) {
    return request({
      url: `/video/branch/node/${nodeId}`,  // DELETE /video/branch/node/{id}
      method: 'delete'
    })
  }
  
  // ===================== 分支选项管理 =====================
  
  // 查询节点下的所有分支选项
  export function listBranchOption(query) {
    return request({
      url: '/video/branch/options',  // GET /video/branch/options
      method: 'get',
      params: query
    })
  }
  
  export function optionDetail(query) {
    return request({
      url: '/video/branch/detail',
      method: 'get',
      params: query
    })
  }

  // 新增分支选项
  export function addBranchOption(data) {
    return request({
      url: '/video/branch/option',  // POST /video/branch/option
      method: 'post',
      data: data
    })
  }

  // 修改分支选项
  export function updateBranchOption(data) {
    return request({
      url: '/video/branch/option',
      method: 'put',
      data: data
    })
  }
  
  // 删除分支选项
  export function delBranchOption(optionId) {
    return request({
      url: `/video/branch/option/${optionId}`, // DELETE /video/branch/option/{id}
      method: 'delete'
    })
  }

  export function batchUpsertNodeVideos(data) {
    return request({
      url: '/video/branch/batchUpsertNodeVideos',  // POST /video/branch/node
      method: 'post',
      data: data
    })
  }
  